export class ExtendedError extends Error {

    constructor(
        message: string,
        readonly info: Record<string, any>,
    ) {
        super(message);
    }
}
